import React from 'react';
import { briefSections } from '../../data/brief';
interface ContentsNavProps {
  active: string;
  onSelect: (id: string) => void;
  /** 'rail' for the sticky desktop column, 'index' for the in-flow phone card. */
  variant?: 'rail' | 'index';
  className?: string;
}
export function ContentsNav({
  active,
  onSelect,
  variant = 'rail',
  className = ''
}: ContentsNavProps) {
  const rail = variant === 'rail';
  return <nav aria-label="Brief contents" className={[rail ? 'sticky top-6 w-[212px] shrink-0 self-start' : 'rounded-[20px] border border-[rgba(1,51,43,0.12)] bg-white p-4', className].join(' ')} data-id="element-145" data-mp="1z9rdawvd3l4i">
      <p className="font-body text-[10px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.4)]" data-id="element-146" data-mp="248cd4v6pc2sf">
        Contents
      </p>
      <ol className={rail ? 'mt-4 space-y-0.5' : 'mt-3 space-y-0.5'} data-id="element-147" data-mp="3kljazihj9r3v">
        {briefSections.map((section, i) => {
        const isActive = rail && active === section.id;
        return <li key={section.id} data-id="element-148" data-mp="yjqa8qbco09h" data-mpi={i}>
              <button type="button" onClick={() => onSelect(section.id)} aria-current={isActive ? 'true' : undefined} className={['flex w-full items-baseline gap-3 rounded-xl px-3 py-2 text-left font-body leading-snug transition-colors', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary', rail ? 'text-[14px]' : 'text-[13px]', isActive ? 'bg-[rgba(1,51,43,0.07)] text-background' : 'text-[rgba(1,51,43,0.52)] hover:text-background'].join(' ')} data-id="element-149" data-mp="yif96y9ah6m2">
                <span className="shrink-0 tabular-nums text-[10px] tracking-[0.12em] text-[rgba(1,51,43,0.35)]" data-id="element-150" data-mp="uier93mzeda9">
                  {String(i + 1).padStart(2, '0')}
                </span>
                {section.nav}
              </button>
            </li>;
      })}
      </ol>
    </nav>;
}